// extracted by mini-css-extract-plugin
export default {"map":"YandexMap_map__5wXpB","errMassage":"YandexMap_errMassage__0-72Q"};